'use strict';

import {
    useState
} from 'react';

import useHasCompanionMode from './useHasCompanionMode.js';


export default function useShowNBQUpsell() {

    const hasCompanionMode = useHasCompanionMode();
    const [shouldShowUpsell, setShouldShowUpsell] = useState(!hasCompanionMode && !RivalIQ.settings.user.settings.hideNBQUpsell);

    const dismissNBQUpsell = function () {
        setShouldShowUpsell(false);
        RivalIQ.execute('persistence:user:save', function (userSettings) {
            userSettings.hideNBQUpsell = true;
        });
        RivalIQ.settings.user.settings.hideNBQUpsell = true;
    };

    return [shouldShowUpsell, dismissNBQUpsell];
}
